module.exports = __webpack_public_path__ + "static/media/PomodoroAppIcon.3c784e4a.svg";